import { render, staticRenderFns } from "./authloading.vue?vue&type=template&id=5f5861f0"
import script from "./authloading.vue?vue&type=script&lang=js"
export * from "./authloading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports